import { defineComponent as _defineComponent } from 'vue'
import { Address } from '@/models/Address';
import { EventOrganizer } from '@/models/EventOrganizer';
import { Location } from '@/models/Location';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TypIcon',
  props: {
    addressRecord: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
    addressRecord: Address | EventOrganizer | Location | null;
    size?: number | string;
};



const iconColor = computed(() =>
    props.addressRecord?.is_visible && props.addressRecord?.status === 'in_union' ? 'ok' : 'grey',
);

return { __sfc: true,props, iconColor }
}

})